import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
// import { Layout } from '../layout/*.vue'
// import { Layout } from "../layout"

const routes = [
  {
    path: '/', // /
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
  {
    path: '/code/:phone/:countryCode',
    name: 'Code',
    component: () => import(/* webpackChunkName: "code" */ '../views/Code.vue'),
  },

  {
    path: '/benchMark',
    name: 'BenchMark',
    component: () => import(/* webpackChunkName: "home" */ '../views/BenchMark.vue'),
  },
  {
    path: '/testPage',
    name: 'TestPage',
    component: () => import(/* webpackChunkName: "login" */ '../views/TestPage.vue'),
  },
  {
    path: '/devops',
    component: () => import(/* webpackChunkName: "home" */ '../layout/LayContent.vue'),
    meta: {
      keepAlive: true,
    },
    children: [
      {
        path: 'regressionPage',
        name: 'RegressionPage',
        component: () => import(/* webpackChunkName: "home" */ '../views/RegressionPage.vue'),
      },
      {
        path: 'coveragePage',
        name: 'CoveragePage',
        component: () => import(/* webpackChunkName: "home" */ '../views/CoveragePage.vue'),
      },
    ]
  },
  {
    path: '/devops/newBenchMark',
    name: 'NewBenchMark',
    component: () => import(/* webpackChunkName: "home" */ '../views/NewBenchMark.vue'),
  },
  
  {
    path: '/infoPage',
    name: 'InfoPage',
    component: () => import(/* webpackChunkName: "home" */ '../views/InfoPage.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
  },

  {
    path: '/benchmark',
    component: () => import(/* webpackChunkName: "home" */ '../layout/LayBenchMark.vue'),
    meta: {
      keepAlive: true,
    },
    children: [
      {
        path: 'sheet/:id?',
        name: 'Sheet',
        component: () => import(/* webpackChunkName: "home" */ '../views/SheetPage.vue'),
       
      },
      {
        path: 'trial/:id?',
        name: 'Trial',
        component: () => import(/* webpackChunkName: "home" */ '../views/TrialPage.vue'),
      },
      {
        path: 'data/:id?',
        name: 'Data',
        component: () => import(/* webpackChunkName: "home" */ '../views/DataPage.vue'),
      },
      {
        path: 'data-builder/:id?',
        name: 'DataBuilder',
        component: () => import(/* webpackChunkName: "home" */ '../views/TrialPage.vue'),
      },
      {
        path: 'sheetcomparepage/:id/:cid',
        name: 'SheetComparePage',
        component: () => import(/* webpackChunkName: "home" */ '../views/SheetComparePage.vue'),
      },
      {
        path: 'triallog/:bucket?/:path?',
        name: 'TrialLog',
        component: () => import(/* webpackChunkName: "home" */ '../views/TrialLog.vue'),
      },
      {
        path: 'report/:trialName?/:columnName?/:trialId?',
        name: 'SheetReport',
        component: () => import(/* webpackChunkName: "home" */ '../views/sheets/SheetReport.vue'),
      },
    ]
  },
  {
    path: '/benchmark/list/:index?',
    name: 'List',
    component: () => import(/* webpackChunkName: "home" */ '../views/TrialSheetDataPage.vue'),
  },

  {
    path: '/cost',
    component: () => import(/* webpackChunkName: "home" */ '../layout/LayBenchMark.vue'),
    children: [
      {
        path: 'sheetlist/:name?/:time?/:length?/:userId?',
        name: 'SheetCostListPage',
        component: () => import(/* webpackChunkName: "home" */ '../views/cost/SheetCostListPage.vue'),
      },
      {
        path: 'triallist/:id/:userId',
        name: 'TrialCostListPage',
        component: () => import(/* webpackChunkName: "home" */ '../views/cost/TrialCostListPage.vue'),
      },
      {
        path: 'userlist',
        name: 'UserCostListPage',
        component: () => import(/* webpackChunkName: "home" */ '../views/cost/UserCostListPage.vue'),
      },
    ]
  },

  {
    path: '/codequality',
    component: () => import(/* webpackChunkName: "home" */ '../layout/LayBenchMark.vue'),
    children: [
      {
        path: 'list/:pageName',
        name: 'MetricsPage',
        component: () => import(/* webpackChunkName: "home" */ '../views/metrics/MetricsPage.vue'),
      },
      {
        path: 'issuetracking/:id',
        name: 'IssueDetailPage',
        component: () => import(/* webpackChunkName: "home" */ '../views/metrics/MetricIssueDetailPage.vue'),
      },
      {
        path: 'assertiondensity/:id',
        name: 'AssertionDetailPage',
        component: () => import(/* webpackChunkName: "home" */ '../views/metrics/MetricAssertionDetailPage.vue'),
      },
      {
        path: 'warning/:id',
        name: 'GccWarningsDetailPage',
        component: () => import(/* webpackChunkName: "home" */ '../views/metrics/MetricGccWarningsDetailPage.vue'),
      },
      {
        path: 'lint/:id',
        name: 'LintDetailPage',
        component: () => import(/* webpackChunkName: "home" */ '../views/metrics/MetricLintDetailPage.vue'),
      },
      {
        path: 'upload',
        name: 'MetricUploadPage',
        component: () => import(/* webpackChunkName: "home" */ '../views/metrics/MetricUploadPage.vue'),
      },
      {
        path: 'coverage',
        name: 'CodeCoveragePage',
        component: () => import(/* webpackChunkName: "home" */ '../views/code-coverage/CodeCoveragePage.vue'),
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
